export const SIZEGUIDE_SHOW_INFO = 'SIZEGUIDE_SHOW_INFO';

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().sizeGuide.showInfo));
};

const show = visible => ({
    type: SIZEGUIDE_SHOW_INFO,
    payload: {
        showInfo: visible,
    },
});
